"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const jsx_runtime_1 = require("react/jsx-runtime");
const cotopaxi_1 = require("@as/cotopaxi");
const useZitcha_1 = require("../../hooks/useZitcha");
function ZitchaBannerContainer({ location, banners }) {
    const { collectClick } = (0, useZitcha_1.useZitcha)();
    const handleClick = (banner) => () => tslib_1.__awaiter(this, void 0, void 0, function* () {
        yield collectClick({
            adFormat: 'native_banner',
            adId: banner.adId,
            placementId: `${location}-${banner.placement}`,
        }).finally(() => {
            /* @ts-expect-error creative.creative should not be there, but its returned */
            window.location.href = (banner.creative.url || banner.creative.creative.url);
        });
    });
    return ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: banners.map(banner => {
            var _a, _b, _c, _d, _e, _f;
            return (banner.creative.mobile || banner.creative.tablet || banner.creative.desktop) && ((0, jsx_runtime_1.jsx)(cotopaxi_1.Teaser, { onClick: handleClick(banner), imageOverlay: cotopaxi_1.TeaserImageOverlay.DARK_66, image: {
                    srcset: Object.assign(Object.assign(Object.assign({}, (((_a = banner.creative.mobile) === null || _a === void 0 ? void 0 : _a.width) && {
                        [`${banner.creative.mobile.width * 2}w`]: banner.creative.mobile.image,
                    })), (((_b = banner.creative.tablet) === null || _b === void 0 ? void 0 : _b.width) && {
                        [`${banner.creative.tablet.width * 2}w`]: banner.creative.tablet.image,
                    })), (((_c = banner.creative.desktop) === null || _c === void 0 ? void 0 : _c.width) && {
                        [`${banner.creative.desktop.width * 2}w`]: banner.creative.desktop.image,
                    })),
                    src: (((_d = banner.creative.desktop) === null || _d === void 0 ? void 0 : _d.image) ||
                        ((_e = banner.creative.tablet) === null || _e === void 0 ? void 0 : _e.image) ||
                        ((_f = banner.creative.mobile) === null || _f === void 0 ? void 0 : _f.image)),
                    alt: 'BANNER',
                } }, banner.adId));
        }) }));
}
exports.default = ZitchaBannerContainer;
